<template>
  <div v-if="block || inline" :class="inline ? 'd-flex align-center gap-4' : null">
    <slot name="title">
      <div><b>{{ packUppercaseTitle }}</b></div>
    </slot>
    <div v-if="desc" class="mt-1">{{ desc }}</div>
    <div v-if="pack" class="mt-1">{{ $t('PREMIUM.FIND_THIS_FEATURE_IN_PACK', { pack: packUppercase }) }}</div>
    <v-btn :class="{ 'mt-4': block }" class="tada-btn" color="success" rounded @click="openPremium()">
      <v-icon start>far fa-unlock</v-icon>
      {{ $t('PREMIUM.UNLOCK') }}
    </v-btn>
    <div v-if="$slots.img" class="mt-2">
      <slot name="img"></slot>
    </div>
  </div>

  <v-card v-else class="premium-section-card d-block d-md-flex">
    <div class="pa-6" style="flex: 0 0 480px">
      <slot name="title">
        <div><b>{{ packUppercaseTitle }}</b></div>
      </slot>
      <div v-if="desc" class="mt-1">{{ desc }}</div>
      <div v-if="pack" class="mt-1">{{ $t('PREMIUM.FIND_THIS_FEATURE_IN_PACK', { pack: packUppercase }) }}</div>
      <div class="text-center">
        <v-btn class="mt-4 tada-btn" color="success" rounded @click="openPremium()">
          <v-icon start>far fa-unlock</v-icon>
          {{ $t('PREMIUM.UNLOCK') }}
        </v-btn>
      </div>
    </div>
    <div v-if="$slots.img" style="flex: 0 1 480px">
      <slot name="img"></slot>
    </div>
  </v-card>
</template>

<style>
  .premium-section-card img {
    max-width: 100%;
  }
</style>

<script>
  export default {
    props: {
      desc: { type: String, default: '' },
      pack: { type: String, default: '' },
      block: { type: Boolean, default: false },
      inline: { type: Boolean, default: false },
    },
    emits: ['open-premium'],
    computed: {
      packUppercase() { return this.pack.toUpperCase(); },
      packUppercaseTitle() {
        if (this.packUppercase == 'ENTERPRISE') return this.$t('PREMIUM.ENTERPRISE_FEATURE');
        if (this.packUppercase == 'BUSINESS') return this.$t('PREMIUM.BUSINESS_FEATURE');
        return this.$t('PREMIUM.PREMIUM_FEATURE');
      },
    },
    methods: {
      openPremium() { this.$emit('open-premium'); },
    },
  };
</script>
